import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/About.css";

const Herowithvideo = ({
  title = "",
  subtitle = "",
  stats = [],
  videoSrc = "",
  videoPoster = "",
  imageSrc = "" 
}) => {
  return (
    <div className="about-hero-section bg-primary-gradient text-white">
      <Container fluid className="py-1">
        <Row className="about-row align-items-start">
          {/* Left Text + Stats */}
          <Col md={5} className="about-left-section">
            {title && (
              <h1
                className="about-title text-white"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}

            {subtitle && (<p className="about-subtitle text-white">{subtitle}</p>)}

            {stats.length > 0 && (
              <div className="about-stats-grid">
                {stats.map((stat, index) => (
                  <div
                    key={index}
                    className="about-stat-card bg-secondary text-primary"
                  >
                    <h3 className="stat-value">{stat.value}</h3>
                    <p className="stat-label">{stat.label}</p>
                  </div>
                ))}
              </div>
            )}
          </Col>

          {/* Right Video/Image */}
          <Col md={7} className="about-right-section d-md-flex">
            <div className="about-video-wrapper w-100">

              {/* ✅ IMAGE VERSION */}
              {imageSrc ? (
                <img
                  src={imageSrc}
                  alt="Hero Image"
                  className="about-video img-fluid rounded"
                  style={{ objectFit: "cover", width: "100%" }}
                />
              ) : (
                <p>No image available</p>
              )}

              {/* 
              ❌ ORIGINAL VIDEO CODE COMMENTED
              {videoSrc ? (
                <video controls poster={videoPoster} className="about-video">
                  <source src={videoSrc} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <p>No video available</p>
              )}
              */}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Herowithvideo;
